import { api } from '@viilutalous/common';

export const sendLogAPI = {
  getAll: (tenantId, params) => api.get(`/${tenantId}/send-log`, { params }),
};
